import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '@/features/auth/AuthProvider';
import { LoginPage } from '@/features/auth/LoginPage';
import { resolveLoginRedirectPath } from '@/features/auth/loginRedirect';

export function AuthenticatedLoginRoute() {
  const { currentUser } = useAuth();
  const location = useLocation();

  if (currentUser) {
    return <Navigate to={resolveLoginRedirectPath(location.search, '/')} replace />;
  }

  return <LoginPage />;
}
